<template>
  <div class="ac-card-content">
    <div class="loyalty-header-container">
      <button
        type="button"
        class="loyalty-close-button"
        @click="close"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="loyalty-close"
        >
      </button>
      <div class="ac-header">
        <span class="loyalty-header">Loyalty Program Points</span>
      </div>
    </div>
    <div class="loyalty-body-container">
      <div class="loyalty-input-container">
        <span class="info-body-txt">
          The term Comfort Credits is customizable. What would you prefer they were called?
        </span>
      </div>
      <div class="loyalty-input-container">
        <input
          id="newName"
          v-model="newName"
          type="text"
          :placeholder="loyaltyName"
          aria-label="newName"
        >
        <div
          v-if="errObj.newName"
          class="error-txt"
        >
          {{ errObj.newName }}
        </div>
      </div>
      <ProcessOverlay
        :show="processing"
        overlayClass="ac-overlay"
      />
    </div>
    <div class="loyalty-footer-container">
      <button
        v-if="loyaltyName !== 'Comfort Credits'"
        type="button"
        class="ac-action-button"
        @click="revertToDefault"
      >
        <img
          src="@shared/assets/img/general/svg/undo-blue.svg"
          alt="Undo"
          class="undo-icon"
        >
        <span class="undo-text">Revert to default</span>
      </button>
      <button
        v-if="loyaltyName !== 'Comfort Credits'"
        type="button"
        class="ac-action-button"
        @click="close"
      >
        <img
          src="@shared/assets/img/general/svg/x-red.svg"
          class="undo-icon"
          alt="Clear"
        >
        <span class="cancel-text">Cancel</span>
      </button>
      <button
        type="button"
        :disabled="!newName || newName === loyaltyName"
        :class="[
          !newName || newName === loyaltyName ? 'inactive' : 'active',
          'form-button',
        ]"
        @click="saveLoyaltyName"
      >
        <div class="align-center">
          <img
            src="@shared/assets/img/general/check-white.png"
            class="white-check"
            alt="Checkmark"
          >
          <span class="save-btn-txt">Save</span>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'ChangeLoyaltyProgramName',
  components: {
    ProcessOverlay,
  },
  props: {
    close: Function,
    partnerSettings: Object,
    update: Function,
  },
  data() {
    return {
      processing: false,
      loyaltyName: '',
      newName: '',
      errObj: {},
    };
  },
  mounted() {
    this.loyaltyName = this.partnerSettings.LOYALTY_PROGRAM_NAME || 'Comfort Credits';
    if (this.loyaltyName !== 'Comfort Credits') {
      this.newName = this.loyaltyName;
    }
  },
  methods: {
    change(f, v) {
      this[f] = v;
    },
    async saveLoyaltyName() {
      this.processing = true;
      const errObj = {};
      const trimmedNewName = this.newName.trim();
      if (!trimmedNewName) {
        errObj.newName = 'Please enter a name';
      }
      if (Object.keys(errObj).length === 0) {
        await this.update({
          LOYALTY_PROGRAM_NAME: trimmedNewName,
        });
        this.$store.dispatch('showSuccessToast', {
          message: `Your points are now called ${trimmedNewName}`,
        });
        this.close();
      }
      this.errObj = errObj;
      this.processing = false;
    },
    async revertToDefault() {
      this.processing = true;
      await this.update({
        LOYALTY_PROGRAM_NAME: 'Comfort Credits',
      });
      this.processing = false;
      this.close();
      this.$store.dispatch('showSuccessToast', {
        message: 'Your points are now called Comfort Credits',
      });
    },
  },
};
</script>
<style lang="scss">

.loyalty-header-container {
  padding: 15px;
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  .ac-header {
    font-size: 1.25rem;
    font-weight: 500;
    margin-left: 5px;
  }

  .ac-close {
    width: 10px;
    height: 10px;
  }

  .loyalty-header {
    font-weight: 600;
    font-size: 16px;
    color: $N80;
  }

  .loyalty-close-button {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    background-color: $N10;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background-color: $N10;
    }

    .loyalty-close {
      width: 10px;
      height: 10px;
    }
  }
}

.loyalty-body-container {
  flex: 1;

  .loyalty-input-container {
    width: 100%;
    padding: 0px 15px 0px 15px;
    margin-bottom: 20px;

    .info-body-txt {
      color: $N80;
      font-weight: 400;
      line-height: 18.72px;
      font-size: 12px;
    }

    input {
      margin-right: 15px;
      padding: 10px;
      border-radius: 8px;
      width: 100%;
      background: $NBLUE10;
      height: 34px;
      font-size: 14px;
      font-weight: 400;

      ::placeholder {
        font-size: 14px;
        font-weight: 400;
        color: $N40;
        ;
      }
    }
  }

  .loyalty-undo-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 15px;

    .undo-icon {
      width: 24px;
      height: 24px;
      border-radius: 4px;
    }

    .undo-text {
      font-size: 14px;
      font-weight: 400;
      color: $NBLUE110;
      margin-left: 10px;
    }

    .cancel-text {
      font-size: 14px;
      font-weight: 400;
      color: $PUNCH;
      margin-left: 5px;
    }
  }
}

.loyalty-footer-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0px 15px 12px;

  .ac-action-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
  }

  .form-button {
    padding: 0 16px;
    height: 40px;
    border-radius: 6px;
    font-weight: 600;
    color: $WHITE;

    &.active {
      background-color: $NBLUE100;
    }
    &.inactive {
      background-color: $N20;
    }
  }

  .white-check {
    width: 15px;
    height: 15px;
  }

  .save-btn-txt {
    margin-left: 8px;
    font-weight: 600;
    font-size: 14px;
  }
}

.undo-icon {
  width: 24px;
  height: 24px;
  border-radius: 4px;
}

.undo-text {
  font-size: 14px;
  font-weight: 400;
  color: $NBLUE110;
  margin-left: 10px;
}

.cancel-text {
  font-size: 14px;
  font-weight: 400;
  color: $PUNCH;
  margin-left: 5px;
}

.error-txt {
  color: $TOMATO100;
  font-size: 0.875rem;
  font-weight: 500;
  padding-left: 4px;
  margin-top: 5px;
}
</style>
